import React from 'react'

import { Loader } from 'react-components/atoms/Icons'

const InfiniteLoader = ({ classes }) => {
  return <Loader classes={'infinite-loader ' + classes} />
}

export default InfiniteLoader
